import {
  GENERAL_RSVP_SESSIONS,
  CHECKOUT_FORM_DATA,
  FORM_LIST,
  ALL_HAS_CONDITIONAL_FIELDS,
  SECTIONWISE_FORM_LIST,
  PROTECTED_PAGE,
  PROGRESS_DATA,
  LAST_FIELD_UPDATED,
} from "@registrationaction";

export let generalRSVPSessions = (state = [], action) => {
  if (action.type === GENERAL_RSVP_SESSIONS) {
    return action.payload;
  }
  return state;
};

export let checkoutFormData = (state = {}, action) => {
  if (action.type === CHECKOUT_FORM_DATA) {
    return action.payload;
  }
  return state;
};

export let formArray = (state = [], action) => {
  if (action.type === FORM_LIST) {
    return action.payload;
  }
  return state;
};

export let allConditionalFields = (state = [], action) => {
  if (action.type === ALL_HAS_CONDITIONAL_FIELDS) {
    return action.payload;
  }
  return state;
};

export let sectionWiseFormArray = (state = [], action) => {
  if (action.type === SECTIONWISE_FORM_LIST) {
    return action.payload;
  }
  return state;
};

export let protectedPage = (state = {}, action) => {
  if (action.type === PROTECTED_PAGE) {
    return action.payload;
  }
  return state;
};

export let progressArray = (state = [], action) => {
  if (action.type === PROGRESS_DATA) {
    return action.payload;
  }
  return state;
};

export let lastFieldUpdated = (state = "", action) => {
  if (action.type === LAST_FIELD_UPDATED) {
    return action.payload;
  }
  return state;
};
